import React from 'react';
import cx from 'classnames';
import { CircularProgress } from '@mui/material';

import { useAppSelector } from 'hooks/store';
import { ThemeModeSelector } from 'store/common';

import wolfLogo from 'assets/logo/wolfLogo.png';
import whiteWolfLogo from 'assets/logo/whiteWolfLogo.png';

import useStyles from './styles';

interface IProps {
  withTransparentBg?: boolean;
  title?: string;
  logoSize?: number;
}

export const DEFAULT_LOGO_SIZE = 70;

const Loader: React.FC<IProps> = ({
  withTransparentBg = false,
  title = '',
  logoSize = DEFAULT_LOGO_SIZE,
}) => {
  const classes = useStyles({ withTransparentBg: withTransparentBg ?? false, logoSize });
  const themeMode = useAppSelector(ThemeModeSelector);
 const isDarkMode = themeMode === 'dark';

  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <CircularProgress className={cx({ [classes.darkIcon]: isDarkMode })}/>
        <img
            src={isDarkMode ? whiteWolfLogo : wolfLogo}
            alt="Wolf Logo"
            className={classes.wolfLogo}
        />
      </div>

      {title && <div className={classes.title}>{title}</div>}
    </div>
  );
};

export default Loader;
